"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5548],{

/***/ 96738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["children", "btnStyle", "className", "type", "onClick", "isClicked", "isForward", "isBack"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Button = function Button(_ref) {
  var children = _ref.children,
      btnStyle = _ref.btnStyle,
      className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      onClick = _ref.onClick,
      _ref$isClicked = _ref.isClicked,
      isClicked = _ref$isClicked === void 0 ? false : _ref$isClicked,
      _ref$isForward = _ref.isForward,
      isForward = _ref$isForward === void 0 ? false : _ref$isForward,
      _ref$isBack = _ref.isBack,
      isBack = _ref$isBack === void 0 ? false : _ref$isBack,
      props = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  switch (btnStyle) {
    case 'normal':
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(NormalButton, {
        type: type,
        onClick: onClick,
        children: children
      });

    case 'transparent':
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(TransparentButton, {
        className: className,
        type: type,
        children: children
      });

    case 'outline':
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(OutlineButton, _objectSpread(_objectSpread({
        className: className,
        type: type,
        onClick: onClick,
        disabled: isClicked,
        "data-is-clicked": isClicked,
        "data-forward": isForward,
        "data-back": isBack
      }, props), {}, {
        children: children
      }));

    case 'square':
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(SquareButton, {
        className: className,
        type: type,
        onClick: onClick,
        children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Arrow, {})]
      });

    default:
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {});
  }
};
var ButtonStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["display:flex;align-items:center;justify-content:center;padding:8px 0;transition:all 0.25s ease;cursor:pointer;"]);
var NormalButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "Button__NormalButton",
  componentId: "sc-1einvqf-0"
})(["", " background-color:", ";color:#fff;width:230px;height:47px;border:none;border-radius:24px;font-size:20px;&:hover{background-color:", ";}@media screen and (max-width:1047px){font-size:18px;}"], ButtonStyle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue);
var TransparentButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "Button__TransparentButton",
  componentId: "sc-1einvqf-1"
})(["", " background-color:transparent;color:", ";border:1px solid ", ";border-radius:29px;width:198px;height:50px;font-size:18px;&:hover{background-color:", ";color:#fff;border:", ";}"], ButtonStyle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue);
var OutlineButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "Button__OutlineButton",
  componentId: "sc-1einvqf-2"
})(["", " background-color:", ";color:#fff;border:2px solid #fff;border-radius:32px;width:275px;height:50px;font-size:18px;font-weight:bold;letter-spacing:1.8px;&[data-forward='true']{width:200px;font-weight:400;border-width:1px;padding-left:35px;&:hover{background-color:", ";border-color:", ";}}&[data-back='true']{width:200px;background-color:", ";font-weight:400;border-width:1px;padding-right:35px;&:hover{background-color:", ";border-color:", ";}}&[data-is-clicked='true']{background-color:", ";color:#fff;cursor:wait;&:hover{background-color:", ";color:#fff;border-width:0;}}&:hover{background-color:", ";border-color:", ";}@media screen and (max-width:1047px){width:262px;height:46px;font-size:16px;}"], ButtonStyle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue);
var SquareButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "Button__SquareButton",
  componentId: "sc-1einvqf-3"
})(["", " background-color:#3786C7;color:#fff;border:none;border-radius:4px;min-width:188px;height:43px;font-size:16px;padding:8px 25px;&:hover{background-color:#3786c7b2;}"], ButtonStyle);
var Arrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdArrowForwardIos */ .KEG).withConfig({
  displayName: "Button__Arrow",
  componentId: "sc-1einvqf-4"
})(["margin-left:8px;"]);

/***/ }),

/***/ 9945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Line; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var Line = function Line(_ref) {
  var className = _ref.className,
      props = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(LineStyle, _objectSpread({
    className: className
  }, props));
};
var LineStyle = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Line__LineStyle",
  componentId: "sc-1insvbt-0"
})(["background-color:", ";", ";"], function (_ref2) {
  var color = _ref2.color;
  return color === 'trialBlue' ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.trialBlue */ .r.colors.trialBlue : color === 'grey' ? '#c0c0c0' : color === 'greyBlue' ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue : '#ffffff';
}, function (_ref3) {
  var direction = _ref3.direction,
      weight = _ref3.weight;
  return direction === 'horizon' ? "height: ".concat(weight, "px") : "width: ".concat(weight, "px");
});

/***/ }),

/***/ 14381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ PageBackground; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var PageBackground = function PageBackground(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      height = _useState[0],
      setHeight = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (true) setHeight(window.document.body.offsetHeight);
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Wrapper, {
    children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(PageBackgroundStyle, {
      scrollHeight: height
    })]
  });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "PageBackground__Wrapper",
  componentId: "sc-17xmdf0-0"
})(["position:relative;"]);
var PageBackgroundStyle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PageBackground__PageBackgroundStyle",
  componentId: "sc-17xmdf0-1"
})(["position:absolute;bottom:0;z-index:-1;background-color:", ";width:100%;height:", "px;clip-path:polygon(0 32%,100% 0,100% 100%,0% 100%);@media screen and (max-width:1047px){clip-path:polygon(0 10%,100% 0,100% 100%,0% 100%);}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue, function (_ref2) {
  var scrollHeight = _ref2.scrollHeight;
  return scrollHeight / 3;
});

/***/ }),

/***/ 17748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var PageTitle = function PageTitle(_ref) {
  var pageTitle = _ref.pageTitle,
      subPageTitle = _ref.subPageTitle;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageTitelDivColor, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageTitelDiv, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PageTitleText, {
        children: [pageTitle, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageSubTitleText, {
          children: subPageTitle
        })]
      })
    })
  });
};
var PageTitelDivColor = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PageTitle__PageTitelDivColor",
  componentId: "sc-14p3yj8-0"
})(["background-color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var PageTitelDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PageTitle__PageTitelDiv",
  componentId: "sc-14p3yj8-1"
})(["width:1040px;display:flex;align-items:center;height:76px;margin:0 auto;padding:22px 0 18px;@media screen and (max-width:1047px){width:100%;padding:12px 20px 9px;height:38px;}"]);
var PageTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
  displayName: "PageTitle__PageTitleText",
  componentId: "sc-14p3yj8-2"
})(["font-size:30px;line-height:36px;font-weight:bold;color:#f4f4f4;font-family:", ";@media screen and (max-width:1047px){font-size:17px;line-height:1;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var PageSubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "PageTitle__PageSubTitleText",
  componentId: "sc-14p3yj8-3"
})(["font-size:20px;line-height:29px;font-weight:normal;color:#ffffff;margin-left:21px;@media screen and (max-width:1047px){font-size:14px;line-height:1;margin-left:14px;}"]);

/***/ }),

/***/ 1253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Spacer; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36864);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Spacer = function Spacer(_ref) {
  var props = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _ref);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(SpacerStyle, _objectSpread({}, props));
};
var SpacerStyle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Spacer__SpacerStyle",
  componentId: "sc-131enc3-0"
})(function (_ref2) {
  var w = _ref2.w,
      h = _ref2.h;
  return [w && "\n    width: ".concat(w.pc, "px;\n    @media (max-width: 1047px) {\n      width: ").concat(w.sp, "px;\n    }\n  "), h && "\n    height: ".concat(h.pc, "px;\n    @media (max-width: 1047px) {\n      height: ").concat(h.sp, "px;\n    }\n  ")];
});

/***/ }),

/***/ 44913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ TopPageTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var TopPageTitle = function TopPageTitle(_ref) {
  var titleText = _ref.titleText,
      subtitleText = _ref.subtitleText,
      enTitleText = _ref.enTitleText,
      imgUrl = _ref.imgUrl;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TopDivColor, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Image, {
      src: imgUrl,
      alt: ""
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TopTitleDiv, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageTitle, {
        children: titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageSubTitle, {
        children: subtitleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnPageTitle, {
        children: enTitleText
      })]
    })]
  });
};
var TopDivColor = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TopPageTitle__TopDivColor",
  componentId: "sc-4jgwk0-0"
})(["height:337px;position:relative;background:rgba(0,45,101,0.6);@media screen and (max-width:1047px){height:180px;}"]);
var Image = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "TopPageTitle__Image",
  componentId: "sc-4jgwk0-1"
})(["position:absolute;top:0;width:100%;height:100%;object-fit:cover;"]);
var TopTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TopPageTitle__TopTitleDiv",
  componentId: "sc-4jgwk0-2"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;position:relative;top:50%;transform:translate(0,-50%);color:#ffffff;text-align:center;"]);
var PageTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
  displayName: "TopPageTitle__PageTitle",
  componentId: "sc-4jgwk0-3"
})(["font-size:42px;font-weight:bold;line-height:50px;margin-bottom:8px;font-family:", ";@media screen and (max-width:1047px){display:none;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var PageSubTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "TopPageTitle__PageSubTitle",
  componentId: "sc-4jgwk0-4"
})(["font-size:32px;line-height:46px;font-weight:normal;@media screen and (max-width:1047px){font-size:24px;line-height:35px;font-weight:bold;}"]);
var EnPageTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
  displayName: "TopPageTitle__EnPageTitle",
  componentId: "sc-4jgwk0-5"
})(["font-size:42px;font-weight:bold;line-height:50px;margin-bottom:8px;font-family:", ";@media screen and (max-width:1047px){font-size:24px;line-height:35px;font-weight:bold;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 55548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cr": function() { return /* binding */ ImageTitleLayout; },
  "Ar": function() { return /* binding */ Layout; },
  "$0": function() { return /* binding */ TitleLayout; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/elements/PageBackground/index.tsx
var PageBackground = __webpack_require__(14381);
// EXTERNAL MODULE: ./src/components/elements/PageTitle/index.tsx
var PageTitle = __webpack_require__(17748);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/elements/TopPageTitle/index.tsx
var TopPageTitle = __webpack_require__(44913);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/layouts/BreadCrumbs/index.tsx







var BreadCrumbs = function BreadCrumbs(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumbsStyle, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
      children: props.breadCrumbs.map(function (_ref) {
        var name = _ref.name,
            path = _ref.path;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
            children: [path ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: path,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumbsLink, {
                children: name
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumbsLink, {
              as: "p",
              children: name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Arrow, {})]
          })
        }, name);
      })
    })
  });
};
var BreadCrumbsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BreadCrumbs__BreadCrumbsStyle",
  componentId: "sc-1w16a6c-0"
})(["width:1040px;margin:0 auto;overflow:hidden;@media screen and (max-width:1047px){width:100%;}"]);
var Wrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "BreadCrumbs__Wrapper",
  componentId: "sc-1w16a6c-1"
})(["display:flex;align-items:center;"]);
var Arrow = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* FiChevronRight */.Tfp).withConfig({
  displayName: "BreadCrumbs__Arrow",
  componentId: "sc-1w16a6c-2"
})(["font-size:20px;margin:0 8px;color:#707070;@media screen and (max-width:1047px){margin:0 4px;font-size:17px;}"]);
var Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "BreadCrumbs__Item",
  componentId: "sc-1w16a6c-3"
})(["display:flex;align-items:center;&:last-child{overflow:hidden;& ", "{display:none;}}"], Arrow);
var BreadCrumbsLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "BreadCrumbs__BreadCrumbsLink",
  componentId: "sc-1w16a6c-4"
})(["display:block;opacity:", ";color:", ";font-size:14px;transition:all 0.25s ease;overflow:", ";text-overflow:ellipsis;white-space:pre;padding:3px;&:hover{", "}@media screen and (max-width:1047px){font-size:12px;line-height:1;}"], function (_ref2) {
  var as = _ref2.as;
  return as ? '' : '0.5';
}, theme/* theme.colors.textTitle */.r.colors.textTitle, function (_ref3) {
  var as = _ref3.as;
  return as ? 'hidden' : 'visible';
}, function (_ref4) {
  var as = _ref4.as;
  return as ? "" : "text-decoration: underline;\n    color: ".concat(theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue, ";opacity:1;");
});
// EXTERNAL MODULE: ./src/utils/routes.ts
var routes = __webpack_require__(97749);
// EXTERNAL MODULE: ./src/components/elements/Line/index.tsx
var Line = __webpack_require__(9945);
;// CONCATENATED MODULE: ./src/components/layouts/Footer/FooterBottom.tsx








var FooterBottom = function FooterBottom() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FooterInner, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FooterLinks, {
        children: routes/* FOOTER_BOTTOM_NAVIGATIONS.map */.Ay.map(function (_ref) {
          var path = _ref.path,
              name = _ref.name;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkLine, {
              color: "white",
              weight: 1,
              direction: "vertical"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: path,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledText, {
                children: name
              })
            })]
          }, "".concat(name));
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterCopyright, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Copyright \xA9 2022 TRIAL Holdings, Inc. all rights reserved."
        })
      })]
    })
  });
};
var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FooterBottom__Footer",
  componentId: "sc-28bdqa-0"
})(["background-color:", ";padding:38px 0 40px;@media screen and (max-width:1047px){padding:41px 0 39px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var FooterInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FooterBottom__FooterInner",
  componentId: "sc-28bdqa-1"
})(["max-width:1047px;margin:0 auto;@media screen and (max-width:1047px){max-width:100%;padding:0 20px;}"]);
var FooterLinks = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "FooterBottom__FooterLinks",
  componentId: "sc-28bdqa-2"
})(["display:flex;justify-content:center;letter-spacing:0.0014em;@media screen and (max-width:1047px){justify-content:flex-start;flex-wrap:wrap;gap:13px 15px;letter-spacing:0.00056em;}"]);
var LinkLine = (0,styled_components_browser_esm/* default */.ZP)(Line/* Line */.x).withConfig({
  displayName: "FooterBottom__LinkLine",
  componentId: "sc-28bdqa-3"
})(["opacity:40%;&:first-child{display:none;}@media screen and (max-width:1047px){display:none;}"]);
var StyledText = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "FooterBottom__StyledText",
  componentId: "sc-28bdqa-4"
})(["color:white;line-height:1;font-size:14px;transition:all 0.25s ease;&:hover{text-decoration:underline;}& + ", "{margin:0 1em;}"], LinkLine);
var FooterCopyright = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FooterBottom__FooterCopyright",
  componentId: "sc-28bdqa-5"
})(["margin-top:15px;text-align:center;p{color:#ffffff;line-height:2.3em;font-size:14px;}@media screen and (max-width:1047px){margin-top:32px;p{font-size:12px;line-height:2.1em;}}"]);
;// CONCATENATED MODULE: ./src/components/layouts/Footer/FooterTop.tsx








var FooterTop = function FooterTop() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FooterTopContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 0,
          pc: 70
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterTopNav, {
        children: routes/* NAVIGATIONS.map */.WY.map(function (_ref, index, array) {
          var path = _ref.path,
              name = _ref.name,
              subdirectories = _ref.subdirectories;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(FooterNavInner, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: path,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FooterNaviTitle, {
                children: name
              })
            }), index < array.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Border, {}), subdirectories && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                h: {
                  sp: 0,
                  pc: 10
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterNaviLinks, {
                children: subdirectories.map(function (_ref2) {
                  var name = _ref2.name,
                      path = _ref2.path,
                      isExternalLink = _ref2.isExternalLink;
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(FooterNaviLinksItem, {
                    children: isExternalLink ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      target: "_blank",
                      rel: "noopener noreferrer",
                      href: path,
                      className: "external-link",
                      children: name
                    }, name) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: path,
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: name
                      })
                    }, name)
                  }, name);
                })
              })]
            })]
          }, name);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 0,
          pc: 70
        }
      })]
    })
  });
};
var FooterTopContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FooterTop__FooterTopContainer",
  componentId: "sc-cdp78b-0"
})(["background-color:", ";"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var FooterTopNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "FooterTop__FooterTopNav",
  componentId: "sc-cdp78b-1"
})(["width:1040px;margin:0 auto;display:flex;justify-content:space-between;@media screen and (max-width:1047px){width:100%;flex-direction:column;padding:0 20px;}"]);
var FooterNavInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FooterTop__FooterNavInner",
  componentId: "sc-cdp78b-2"
})(["font-size:14px;"]);
var Border = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FooterTop__Border",
  componentId: "sc-cdp78b-3"
})(["@media screen and (max-width:1047px){width:100vw;margin:0 calc(50% - 50vw);border-bottom:1px solid ", ";}"], theme/* theme.colors.backgroundBlue */.r.colors.backgroundBlue);
var FooterNaviTitle = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "FooterTop__FooterNaviTitle",
  componentId: "sc-cdp78b-4"
})(["display:block;font-weight:bold;line-height:20px;transition:all 0.25s ease;&:hover{text-decoration:underline;color:", ";}@media screen and (max-width:1047px){font-size:15px;line-height:21px;padding:18px 0;display:flex;justify-content:space-between;align-items:center;&:after{content:'';background:url('/images/angle-right.svg') no-repeat;width:12px;height:17px;}}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var FooterNaviLinks = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "FooterTop__FooterNaviLinks",
  componentId: "sc-cdp78b-5"
})(["@media screen and (max-width:1047px){display:none;}"]);
var FooterNaviLinksItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "FooterTop__FooterNaviLinksItem",
  componentId: "sc-cdp78b-6"
})(["transition:all 0.25s ease;a{display:block;line-height:32px;}&:hover{a{text-decoration:underline;color:", ";}.external-link:after{background:url('/images/external-link-hoverblue.svg') no-repeat;}}.external-link{&:after{content:'';background:url('/images/external-link-black.svg') no-repeat;width:12px;height:12px;margin-left:8px;display:inline-block;}}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
;// CONCATENATED MODULE: ./src/components/layouts/Footer/index.tsx





var FooterArea = function FooterArea() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Footer_Footer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FooterTop, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterBottom, {})]
  });
};
var Footer_Footer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
  displayName: "Footer",
  componentId: "sc-tx6h11-0"
})([""]);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/utils/convertPx.ts
var convertPx = __webpack_require__(98993);
// EXTERNAL MODULE: ./src/components/elements/Button/index.tsx
var Button = __webpack_require__(96738);
;// CONCATENATED MODULE: ./src/components/layouts/Header/LinkCard.tsx





var LinkCard = function LinkCard(_ref) {
  var title = _ref.title,
      imgPath = _ref.imgPath,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ItemLink, {
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BgImage, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: imgPath,
        alt: title
      })
    })
  });
};
var LinkButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
  displayName: "LinkCard__LinkButton",
  componentId: "sc-14zhucf-0"
})(["position:absolute;bottom:17px;left:50%;transform:translateX(-50%);@media screen and (max-width:1047px){max-width:262px;width:", ";}"], (0,convertPx/* PxToVw */.g)(262, 390));
var BgImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LinkCard__BgImage",
  componentId: "sc-14zhucf-1"
})(["position:relative;display:flex;justify-content:center;height:100%;transition:opacity,background-color 0.3s;background-color:", ";border-radius:8px;img{width:100%;height:100%;object-fit:cover;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var ItemLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LinkCard__ItemLink",
  componentId: "sc-14zhucf-2"
})(["display:block;border-radius:8px;background-color:", ";width:316px;height:188px;position:relative;transition:all 0.25s ease;&:hover ", "{opacity:0.6;background-color:#e5f5fc66;}&:hover ", "{border-color:#fff;background-color:", ";color:#ffffff;}@media screen and (max-width:1047px){max-width:350px;width:", ";height:208px;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue, BgImage, LinkButton, theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue, (0,convertPx/* PxToVw */.g)(350, 390));
;// CONCATENATED MODULE: ./src/components/layouts/Header/DrawerNaviItem.tsx






var DrawerNaviItem = function DrawerNaviItem(_ref) {
  var link = _ref.link,
      imgPath = _ref.imgPath,
      title = _ref.title,
      _ref$isExternalLink = _ref.isExternalLink,
      isExternalLink = _ref$isExternalLink === void 0 ? false : _ref$isExternalLink;

  var handleClick = function handleClick(e) {
    e.preventDefault();
    window.location.href = link;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DrawerNaviItem_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DrawerNaviItemStyled, {
      imgPath: imgPath
    }), isExternalLink ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: link,
      className: "drawer-link external-link",
      children: title
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      href: link,
      onClick: handleClick,
      className: "drawer-link focus-item",
      children: [title, /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerNaviItem_Arrow, {
        color: "#3786C7"
      })]
    })]
  });
};
var DrawerNaviItemStyled = (0,styled_components_browser_esm/* default */.ZP)(LinkCard).withConfig({
  displayName: "DrawerNaviItem__DrawerNaviItemStyled",
  componentId: "sc-1w5uz2k-0"
})(["width:100%;height:110px;@media screen and (max-width:1920px){height:90px;}img{object-fit:fill;}"]);
var DrawerNaviItem_Arrow = (0,styled_components_browser_esm/* default */.ZP)(md_index_esm/* MdArrowForwardIos */.KEG).withConfig({
  displayName: "DrawerNaviItem__Arrow",
  componentId: "sc-1w5uz2k-1"
})(["margin-left:8px;margin-bottom:2px;"]);
var DrawerNaviItem_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DrawerNaviItem__Wrapper",
  componentId: "sc-1w5uz2k-2"
})(["position:relative;width:190px;height:152px;@media screen and (max-width:1920px){height:110px;}.drawer-link{white-space:nowrap;position:absolute;bottom:0px;left:0px;width:125%;height:100%;display:flex;align-items:baseline;color:#fff;line-height:24px;padding-top:120px;@media screen and (max-width:1920px){padding-top:90px;}letter-spacing:1.6px;&:hover{color:", ";}}.external-link{&:after{content:'';background:url('/images/external-link.svg') no-repeat;width:12px;height:12px;margin-left:8px;display:inline-block;}}&:hover ", "{opacity:0.6;}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue, DrawerNaviItemStyled);
;// CONCATENATED MODULE: ./src/components/layouts/Header/index.tsx













var Header = function Header() {
  var _useState = (0,react.useState)(false),
      isNaviOpen = _useState[0],
      setIsNaviOpen = _useState[1];

  var _useState2 = (0,react.useState)(-1),
      spNaviClicked = _useState2[0],
      setSpNaviClicked = _useState2[1];

  var _useState3 = (0,react.useState)(-1),
      pcNaviFocused = _useState3[0],
      setPcNaviFocused = _useState3[1];

  var id = (0,react.useId)();

  var toggleMenu = function toggleMenu() {
    setIsNaviOpen(!isNaviOpen);
    setSpNaviClicked(-1);
  };

  var toggleItem = function toggleItem(index) {
    if (spNaviClicked === index) {
      return setSpNaviClicked(-1);
    }

    setSpNaviClicked(index);
  };

  var handleOverlayClick = function handleOverlayClick() {
    setIsNaviOpen(false);
  };

  var drawerItem = function drawerItem(index) {
    setPcNaviFocused(index);
  };

  var unDrawerItem = function unDrawerItem() {
    setPcNaviFocused(-1);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Header_Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        passHref: true,
        tabIndex: 0,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/images/logo.svg",
            alt: "\u30ED\u30B4"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PcNavi, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LineStyled, {
          color: "grey",
          weight: 1,
          direction: "vertical"
        }), routes/* NAVIGATIONS.map */.WY.map(function (_ref, index) {
          var path = _ref.path,
              name = _ref.name,
              subdirectories = _ref.subdirectories;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWrapper, {
              tabIndex: 0,
              onFocus: function onFocus() {
                return drawerItem(index);
              },
              onMouseOver: function onMouseOver() {
                return drawerItem(index);
              },
              onBlur: function onBlur() {
                return unDrawerItem();
              },
              onMouseLeave: function onMouseLeave() {
                return unDrawerItem();
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: path,
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  tabIndex: -1,
                  children: name
                })
              }), subdirectories.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Drawer, {
                className: pcNaviFocused === index ? 'focused' : '',
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DrawerInner, {
                  className: pcNaviFocused === index ? 'focused' : '',
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DrawerHead, {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: path,
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          children: name
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DrawerBtn, {
                          btnStyle: "square",
                          children: [name, "\u30C8\u30C3\u30D7"]
                        })]
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerNavi, {
                    children: subdirectories.map(function (_ref2) {
                      var path = _ref2.path,
                          name = _ref2.name,
                          imagePath = _ref2.imagePath,
                          isExternalLink = _ref2.isExternalLink;
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerNaviItem, {
                        link: path,
                        imgPath: imagePath,
                        title: name,
                        isExternalLink: isExternalLink
                      }, path);
                    })
                  })]
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(LineStyled, {
              color: "grey",
              weight: 1,
              direction: "vertical"
            })]
          }, name);
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Language, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Globalicon, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/images/global_icon.svg",
            alt: "\u30B0\u30ED\u30FC\u30D0\u30EB\u30A2\u30A4\u30B3\u30F3"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Japaniese, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "JA"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Vector, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/images/vector.svg",
            alt: "\u30D9\u30AF\u30BF\u30FC"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/en",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(English, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "EN"
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HamburgerMenu, {
        "aria-expanded": isNaviOpen ? 'true' : 'false',
        onClick: function onClick() {
          return toggleMenu();
        },
        "aria-label": "\u30E1\u30CB\u30E5\u30FC",
        "aria-controls": id,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpNavi, {
      id: id,
      "aria-hidden": !isNaviOpen,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        children: routes/* NAVIGATIONS.map */.WY.map(function (_ref3, index) {
          var name = _ref3.name,
              subdirectories = _ref3.subdirectories,
              path = _ref3.path;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(NaviItem, {
            "aria-expanded": isNaviOpen && spNaviClicked === index ? 'true' : 'false',
            "aria-controls": "".concat(name, "\u306E\u30E1\u30CB\u30E5\u30FC"),
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(NaviParent, {
              onClick: function onClick() {
                return toggleItem(index);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: name
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Icon, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})]
              })]
            }), subdirectories && /*#__PURE__*/(0,jsx_runtime.jsxs)(NaviChildren, {
              id: "".concat(name, "\u306E\u30E1\u30CB\u30E5\u30FC"),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                onClick: function onClick() {
                  return toggleMenu();
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: path,
                  passHref: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiChevronRight */.Tfp, {
                      color: theme/* theme.colors.trialBlue */.r.colors.trialBlue,
                      size: 22
                    }), name, "\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8"]
                  })
                })
              }), subdirectories === null || subdirectories === void 0 ? void 0 : subdirectories.map(function (_ref4) {
                var path = _ref4.path,
                    name = _ref4.name,
                    isExternalLink = _ref4.isExternalLink;
                return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  onClick: function onClick() {
                    return toggleMenu();
                  },
                  children: isExternalLink ? /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: path,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiChevronRight */.Tfp, {
                      color: theme/* theme.colors.trialBlue */.r.colors.trialBlue,
                      size: 22
                    }), name, /*#__PURE__*/(0,jsx_runtime.jsx)(ExLinkIcon, {
                      size: "1em"
                    })]
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: path,
                    passHref: true,
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiChevronRight */.Tfp, {
                        color: theme/* theme.colors.trialBlue */.r.colors.trialBlue,
                        size: 22
                      }), name]
                    })
                  })
                }, name);
              })]
            })]
          }, name);
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Overlay, {
      "aria-hidden": !isNaviOpen,
      onClick: handleOverlayClick,
      role: "button",
      tabIndex: -1,
      "aria-label": "\u30E1\u30CB\u30E5\u30FC\u3092\u9589\u3058\u308B"
    })]
  });
};
var Header_Wrapper = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
  displayName: "Header__Wrapper",
  componentId: "sc-1f6qe1y-0"
})(["height:105px;position:fixed;top:0;width:100%;z-index:999;padding:0 48px;display:flex;align-items:center;justify-content:space-between;background-color:#fff;@media screen and (max-width:1047px){height:53px;padding:0 16px;}"]);
var Logo = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Header__Logo",
  componentId: "sc-1f6qe1y-1"
})(["position:relative;display:block;width:300px;height:27px;img{width:100%;height:100%;}@media screen and (max-width:1047px){width:180px;height:16px;}"]);
var PcNavi = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "Header__PcNavi",
  componentId: "sc-1f6qe1y-2"
})(["display:flex;height:100%;margin-left:auto;margin-right:20px;padding:0px 20px;@media screen and (max-width:1047px){display:none;}"]);
var HamburgerLine = (0,styled_components_browser_esm/* css */.iv)(["position:absolute;width:26px;height:2px;background-color:", ";transition:all 0.5s;left:0;"], theme/* theme.colors.textTitle */.r.colors.textTitle);
var HamburgerMenu = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Header__HamburgerMenu",
  componentId: "sc-1f6qe1y-3"
})(["display:none;position:relative;width:25px;height:23px;border:0;background-color:transparent;span{&:nth-child(1){", ";top:0;}&:nth-child(2){", ";top:10px;}&:nth-child(3){", ";top:20px;}}&[aria-expanded='true'] span{&:nth-child(1){transform:translateY(0.7rem) rotate(-45deg);}&:nth-child(2){opacity:0;}&:nth-child(3){transform:translateY(-0.5rem) rotate(45deg);}}@media screen and (max-width:1047px){display:block;}"], HamburgerLine, HamburgerLine, HamburgerLine);
var SpNavi = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "Header__SpNavi",
  componentId: "sc-1f6qe1y-4"
})(["position:fixed;top:53px;width:100%;background-color:#fff;transform:translateY(calc(-100vh - 53px));transition:all 1s ease-in-out;z-index:-1;&[aria-hidden='false']{z-index:99;transform:translateY(0);transition:all 0.5s ease-in-out;}&[aria-hidden='true'] > *{display:none;}"]);
var NaviChildren = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Header__NaviChildren",
  componentId: "sc-1f6qe1y-5"
})(["max-height:0;overflow:hidden;opacity:0;transition:all 0.25s ease;visibility:hidden;li{height:53px;padding:0 37px;}a{display:flex;align-items:center;font-size:14px;height:100%;width:100%;border-bottom:1px solid ", ";:hover{text-decoration:underline;color:", ";}}svg{margin-right:6px;}li:nth-child(1){border-bottom:1px solid ", ";a{font-size:16px;border-bottom:none;}}"], theme/* theme.colors.backgroundBlue */.r.colors.backgroundBlue, theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue, theme/* theme.colors.backgroundBlue */.r.colors.backgroundBlue);
var NaviParent = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Header__NaviParent",
  componentId: "sc-1f6qe1y-6"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;height:71px;padding:0 19px;border:none;background:#ffffff;span{font-size:16px;font-weight:bold;}"]);
var Icon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Header__Icon",
  componentId: "sc-1f6qe1y-7"
})(["position:relative;background:transparent;border:0;width:15px;height:15px;span{position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);display:block;width:100%;height:2px;background-color:#b5bdc4;transition:all 0.5s;&:nth-child(2){transform:translateX(-50%) translateY(-50%) rotate(90deg);}}"]);
var NaviItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "Header__NaviItem",
  componentId: "sc-1f6qe1y-8"
})(["border-top:1px solid ", ";&[aria-expanded='true']{background-color:rgba(225,232,239,0.3);", "{max-height:100dvh;max-height:100vh;opacity:1;padding-bottom:36px;visibility:visible;}", "{border-bottom:1px solid ", ";span{color:", ";}}", " span{&:nth-child(1){opacity:0;}&:nth-child(2){transform:translateX(-50%) translateY(-50%) rotate(0deg);background-color:", ";}}}"], theme/* theme.colors.backgroundBlue */.r.colors.backgroundBlue, NaviChildren, NaviParent, theme/* theme.colors.backgroundBlue */.r.colors.backgroundBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue, Icon, theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Header__Overlay",
  componentId: "sc-1f6qe1y-9"
})(["position:fixed;top:53px;right:0;bottom:0;left:0;z-index:9;display:none;background-color:#3a3c3e;opacity:0.6;&[aria-hidden='false']{display:block;}"]);
var Drawer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Header__Drawer",
  componentId: "sc-1f6qe1y-10"
})(["position:absolute;max-height:0;top:105px;left:0;width:100vw;background-color:", ";transition:all 0.3s ease-in-out;display:flex;align-items:center;visibility:hidden;&.focused{max-height:596px;transition:all 0.3s ease-in-out;visibility:visible;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var DrawerInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Header__DrawerInner",
  componentId: "sc-1f6qe1y-11"
})(["width:1040px;max-height:0;margin:0 auto;display:flex;column-gap:40px;overflow:hidden;transition:all 0.3s ease-in-out;visibility:hidden;&.focused{padding:50px 0;max-height:596px;transition:all 0.3s ease-in-out;visibility:visible;}"]);
var DrawerHead = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Header__DrawerHead",
  componentId: "sc-1f6qe1y-12"
})(["flex-shrink:0;p{font-size:30px;font-weight:bold;color:#fff;margin-bottom:18px;}"]);
var DrawerBtn = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
  displayName: "Header__DrawerBtn",
  componentId: "sc-1f6qe1y-13"
})(["white-space:nowrap;"]);
var DrawerNavi = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Header__DrawerNavi",
  componentId: "sc-1f6qe1y-14"
})(["display:flex;flex-wrap:wrap;gap:32px 40px;"]);
var LineStyled = (0,styled_components_browser_esm/* default */.ZP)(Line/* Line */.x).withConfig({
  displayName: "Header__LineStyled",
  componentId: "sc-1f6qe1y-15"
})(["margin:44.5px 0;height:16px;"]);
var LinkWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Header__LinkWrapper",
  componentId: "sc-1f6qe1y-16"
})(["padding:44.5px 24px;font-weight:bold;display:flex;align-items:center;> a{display:flex;align-items:center;height:105px;}&:hover{cursor:pointer;& > a{color:", ";}}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var ExLinkIcon = (0,styled_components_browser_esm/* default */.ZP)(bi_index_esm/* BiCopy */.LhG).withConfig({
  displayName: "Header__ExLinkIcon",
  componentId: "sc-1f6qe1y-17"
})(["margin-left:6px;"]);
var Language = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Header__Language",
  componentId: "sc-1f6qe1y-18"
})(["display:flex align-items:center;@media screen and (max-width:1047px){margin-left:auto;margin-right:10px;}&:hover{color:#4D84C2;}"]);
var Globalicon = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Header__Globalicon",
  componentId: "sc-1f6qe1y-19"
})(["width:14px;height:13px;margin-right:7px;"]);
var Japaniese = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Header__Japaniese",
  componentId: "sc-1f6qe1y-20"
})(["text-align:center;font-family:Noto Sans JP;font-size:15px;font-style:normal;font-weight:700;line-height:100%;text-decoration-line:underline;margin-right:4px"]);
var Vector = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Header__Vector",
  componentId: "sc-1f6qe1y-21"
})(["width:10px;height:12px;margin-right:10px;stroke-width:1px;stroke:var(--black,#3A3C3E);margin-right:4px"]);
var English = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Header__English",
  componentId: "sc-1f6qe1y-22"
})(["cursor:pointer;text-align:center;font-family:Noto Sans JP;font-size:15px;font-style:normal;font-weight:700;line-height:100%;margin-right:4px;"]);
;// CONCATENATED MODULE: ./src/components/layout.tsx











var Layout = function Layout(_ref) {
  var children = _ref.children,
      isRequiredBackground = _ref.isRequiredBackground;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header, {}), isRequiredBackground ? /*#__PURE__*/(0,jsx_runtime.jsx)(PageBackground/* PageBackground */.q, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Main, {
        children: children
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Main, {
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterArea, {})]
  });
};
var TitleLayout = function TitleLayout(_ref2) {
  var title = _ref2.title,
      subTitle = _ref2.subTitle,
      breadCrumbs = _ref2.breadCrumbs,
      children = _ref2.children,
      isRequiredBackground = _ref2.isRequiredBackground;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Main, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageTitle/* PageTitle */.V, {
        pageTitle: title,
        subPageTitle: subTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 10,
            pc: 14
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumbs, {
          breadCrumbs: breadCrumbs
        })]
      }), isRequiredBackground ? /*#__PURE__*/(0,jsx_runtime.jsx)(PageBackground/* PageBackground */.q, {
        children: children
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterArea, {})]
  });
};
var ImageTitleLayout = function ImageTitleLayout(_ref3) {
  var title = _ref3.title,
      subTitle = _ref3.subTitle,
      imgUrl = _ref3.imgUrl,
      breadCrumbs = _ref3.breadCrumbs,
      children = _ref3.children,
      isRequiredBackground = _ref3.isRequiredBackground;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Main, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TopPageTitle/* TopPageTitle */.l, {
        titleText: title,
        subtitleText: subTitle,
        imgUrl: imgUrl
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 10,
          pc: 14
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 10,
            pc: 14
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumbs, {
          breadCrumbs: breadCrumbs
        })]
      }), isRequiredBackground ? /*#__PURE__*/(0,jsx_runtime.jsx)(PageBackground/* PageBackground */.q, {
        children: children
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterArea, {})]
  });
};
var layout_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "layout__Wrapper",
  componentId: "sc-1nrgu7y-0"
})(["@media screen and (max-width:1047px){display:none;}"]);
var Main = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
  displayName: "layout__Main",
  componentId: "sc-1nrgu7y-1"
})(["padding-top:105px;@media screen and (max-width:1047px){padding-top:53px;}"]);

/***/ }),

/***/ 98993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ PxToVw; }
/* harmony export */ });
/* unused harmony export PxToVh */
var PxToVw = function PxToVw(px, baseWidth) {
  return "".concat(px * (100 / baseWidth), "vw");
};
var PxToVh = function PxToVh(px, baseHeight) {
  return "".concat(px * (100 / baseHeight), "vh");
};

/***/ }),

/***/ 97749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ay": function() { return /* binding */ FOOTER_BOTTOM_NAVIGATIONS; },
/* harmony export */   "C_": function() { return /* binding */ IR_LIBRARY_ROUTE; },
/* harmony export */   "Dt": function() { return /* binding */ IR_INVESTOR_ROUTE; },
/* harmony export */   "Ir": function() { return /* binding */ COMPANY_ROUTE; },
/* harmony export */   "Oh": function() { return /* binding */ IR_FINANCIAL_ROUTE; },
/* harmony export */   "UT": function() { return /* binding */ IR_PICKUP_ROUTE; },
/* harmony export */   "WY": function() { return /* binding */ NAVIGATIONS; },
/* harmony export */   "Xp": function() { return /* binding */ IR_MANAGE_ROUTE; },
/* harmony export */   "Zj": function() { return /* binding */ LEGAL_ROUTE; },
/* harmony export */   "aQ": function() { return /* binding */ IR_STOCK_ROUTE; },
/* harmony export */   "by": function() { return /* binding */ IR_GOVERNANCE_ROUTE; },
/* harmony export */   "fR": function() { return /* binding */ SITE_MAP_NAVIGATION; },
/* harmony export */   "go": function() { return /* binding */ CAREERS_ROUTE; },
/* harmony export */   "kd": function() { return /* binding */ IR_TOP_ROUTE; },
/* harmony export */   "yE": function() { return /* binding */ IR_OTHER_ROUTE; },
/* harmony export */   "y_": function() { return /* binding */ CONTACT_ROUTE; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76687);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var COMPANY_ROUTE = {
  path: '/company/',
  name: '企業情報',
  subdirectories: [{
    path: '/company/topmessage/',
    name: 'トップメッセージ',
    imagePath: '/images/company-top-message-link.svg',
    isExternalLink: false
  }, {
    path: '/company/philosophy/',
    name: '経営理念',
    imagePath: '/images/company-philosophy-link.svg',
    isExternalLink: false
  }, {
    path: '/company/overview/',
    name: '会社概要',
    imagePath: '/images/company-overview-link.svg',
    isExternalLink: false
  }, {
    path: '/company/officer/',
    name: '役員一覧',
    imagePath: '/images/drawer-officer-links.svg',
    isExternalLink: false
  }, {
    path: '/company/history/',
    name: '会社沿革',
    imagePath: '/images/company-history-link.svg',
    isExternalLink: false
  }, {
    path: '/company/access/',
    name: 'アクセス',
    imagePath: '/images/company-access-link.svg',
    isExternalLink: false
  }]
};
var BUSINESS_ROUTE = {
  path: '/business/',
  name: '事業内容',
  subdirectories: [{
    path: '/business/#retail',
    name: '流通小売事業',
    imagePath: '/images/business-retail-links.svg',
    isExternalLink: false
  }, {
    path: '/business/#retail-ai',
    name: 'リテールAI事業',
    imagePath: '/images/business-retail-ai-links.svg',
    isExternalLink: false
  }, {
    path: '/business/#others',
    name: 'その他',
    imagePath: '/images/business-other-links.svg',
    isExternalLink: false
  }]
};
var NEWS_ROUTE = {
  path: '/news/',
  name: 'ニュースルーム',
  subdirectories: [{
    path: '/news/release/',
    name: 'ニュースリリース',
    imagePath: '/images/news-release.svg',
    isExternalLink: false
  }, {
    path: '/news/blog/',
    name: '広報ブログ',
    imagePath: '/images/news-blog.svg',
    isExternalLink: false
  }, {
    path: '/news/media/',
    name: 'メディアキット',
    imagePath: '/images/news-media-kit.svg',
    isExternalLink: false
  }, {
    path: '/news/video/',
    name: 'ビデオライブラリー',
    imagePath: '/images/news-video-library.svg',
    isExternalLink: false
  }, {
    path: '/news/exposure/',
    name: 'メディア露出一覧',
    imagePath: '/images/news-media-exposure.svg',
    isExternalLink: false
  }, {
    path: '/news/machidukuri/',
    name: '街づくりプロジェクト',
    imagePath: '/images/news-machidukuri.svg',
    isExternalLink: false
  }, {
    path: '/remoteworktown/',
    name: 'リモートワークタウン',
    imagePath: '/images/news-remoteworktown.svg',
    isExternalLink: false
  }]
};
var IR_TOP_ROUTE = {
  path: '/ir/',
  name: '株主・投資家向け情報',
  subdirectories: [{
    name: 'トップメッセージ',
    path: '/company/topmessage/',
    imagePath: '/images/company-top-message-link.svg',
    isExternalLink: false
  }, {
    name: '',
    path: '/ir/library/financial-announcement/',
    imagePath: '/images/serch_graph.svg',
    isExternalLink: false
  }, {
    name: '個人投資家の皆様へ',
    path: '/ir/investor',
    imagePath: '/images/bussiness-man-and-woman.svg',
    isExternalLink: false
  }, {
    name: 'IRニュース',
    path: '/ir/news/',
    imagePath: '',
    isExternalLink: false
  }, {
    name: '株価情報',
    path: '/ir/stock/price/',
    imagePath: '',
    isExternalLink: false
  }, {
    name: '月次売上高速報',
    path: '/ir/financial/monthly-sales/',
    imagePath: '',
    isExternalLink: false
  }, {
    name: 'IRカレンダー',
    path: '/ir/calendar/',
    imagePath: '',
    isExternalLink: false
  }]
};
var IR_MANAGE_ROUTE = {
  path: '/ir/manage/',
  name: '経営方針',
  imagePath: '/images/globalnavi-ir-manage.svg',
  isExternalLink: false,
  subdirectories: [{
    name: 'トップメッセージ',
    path: '/company/topmessage/',
    imagePath: '/images/company-top-message-link.svg',
    detail: 'トップメッセージ「リテールDXを通じて世の中を豊かな社会へ」を掲載しております。',
    isExternalLink: false
  }, {
    name: '経営理念',
    path: '/company/philosophy/',
    imagePath: '/images/company-philosophy-link.svg',
    detail: '当社グループのパーパス、ビジョン、バリューについて掲載しております。',
    isExternalLink: false
  }, {
    name: '事業計画及び成長可能性',
    path: '/ir/library/projection/',
    imagePath: '/images/projection-link.svg',
    detail: '当社グループのビジネスモデルや、中長期的な成長を実現するための戦略、施策などについて掲載しております。',
    isExternalLink: false
  }, {
    name: '対処すべき課題',
    path: '/ir/manage/issue/',
    imagePath: '/images/issue-link.svg',
    detail: '優先的に対処すべき事業上の課題について掲載しております。',
    isExternalLink: false
  }, {
    name: '事業等のリスク',
    path: '/ir/manage/risk/',
    imagePath: '/images/risk-link.svg',
    detail: '事業領域ごとに想定されるリスクについて掲載しております。',
    isExternalLink: false
  }, {
    name: 'ディスクロージャー・IRポリシー',
    path: '/ir/manage/disclosure/',
    imagePath: '/images/disclosure-link.svg',
    detail: 'IR活動における基本方針について掲載しております。',
    isExternalLink: false
  }]
};
var IR_GOVERNANCE_ROUTE = {
  path: '/ir/governance/',
  name: 'コーポレート・ガバナンス',
  isExternalLink: false,
  imagePath: '/images/globalnavi-ir-govanance.svg',
  subdirectories: [{
    name: 'コーポレート・ガバナンスに関する基本的な考え方',
    path: '/ir/governance/basics/',
    imagePath: '/images/ir-governance-basics.webp',
    detail: 'コーポレート・ガバナンスに関する基本的な考え方について掲載しております。',
    isExternalLink: false
  }, {
    name: 'コーポレート・ガバナンス体制',
    path: '/ir/governance/organization/',
    imagePath: '/images/ir-governance-organization.webp',
    detail: '企業統治体制の概要と当該体制を採用する理由について掲載しております。',
    isExternalLink: false
  }, {
    name: '役員一覧',
    path: '/company/officer/',
    imagePath: '/images/officer-link.svg',
    detail: '当社の役員情報について掲載しております。',
    isExternalLink: false
  }, {
    name: 'ステークホルダーに関わる施策',
    path: '/ir/governance/policy/',
    imagePath: '/images/ir-governance-policy.webp',
    detail: 'ステークホルダーの立場の尊重に係る取組み状況について掲載しております。',
    isExternalLink: false
  }, {
    name: '内部統制システムに関する基本方針',
    path: '/ir/governance/internal-control/',
    imagePath: '/images/ir-governance-internal-control.webp',
    detail: '内部統制システム及びリスク管理体制の整備の状況について掲載しております。',
    isExternalLink: false
  }, {
    name: '反社会的勢力への対応',
    path: '/ir/governance/antisocial/',
    imagePath: '/images/ir-governance-antisocial.webp',
    detail: '反社会的勢力排除に向けた基本的な考え方及びその整備状況について掲載しております。',
    isExternalLink: false
  }]
};
var IR_FINANCIAL_ROUTE = {
  path: '/ir/financial/',
  name: '業績・財務情報',
  imagePath: '/images/globalnavi-ir-financial.svg',
  isExternalLink: false,
  subdirectories: [{
    name: '月次売上高速報',
    path: '/ir/financial/monthly-sales/',
    imagePath: '/images/ir-financial-monthly.webp',
    detail: '当社グループ営業店舗における月次売上高速報について掲載しております。',
    isExternalLink: false
  }, {
    name: '決算レビュー',
    path: '/ir/financial/review/',
    imagePath: '/images/ir-financial-review.webp',
    detail: '四半期ごとの決算概要について掲載しております。',
    isExternalLink: false
  }, // pathをhttps;でリロードする
  {
    name: '連結財務諸表',
    path: '/ir/financial/cfs/',
    imagePath: '/images/ir-financial-cfs.webp',
    detail: '当社グループの連結PL、BS、CFについて掲載しております。',
    isExternalLink: false
  }, // pathをhttps;でリロードする
  {
    name: '連結業績予想',
    path: '/ir/financial/forecast/',
    imagePath: '/images/ir-financial-forecast.webp',
    detail: '当社グループの連結業績予想について掲載しております。',
    isExternalLink: false
  }]
};
var IR_LIBRARY_ROUTE = {
  path: '/ir/library/',
  name: 'IRライブラリー',
  imagePath: '/images/globalnavi-ir-library.svg',
  isExternalLink: false,
  subdirectories: [{
    name: '決算関連資料',
    path: '/ir/library/financial-announcement/',
    imagePath: '/images/irlibrary-financial-announcement-card.svg',
    detail: '決算短信及び決算説明資料について掲載しております。',
    isExternalLink: false
  }, {
    name: '有価証券報告書',
    imagePath: '/images/irlibrary-securities-card.svg',
    detail: '四半期報告書及び有価証券報告書について掲載しております。',
    path: '/ir/library/securities/',
    isExternalLink: false
  }, {
    name: '事業計画及び成長可能性',
    path: '/ir/library/projection/',
    imagePath: '/images/irlibrary-projection-card.svg',
    detail: '当社グループのビジネスモデルや、中長期的な成長を実現するための戦略、施策などについて掲載しております。',
    isExternalLink: false
  }, {
    name: '株主通信',
    path: '/ir/investor/',
    imagePath: '/images/news-blog.svg',
    detail: '環境配慮の観点から、株主通信はWeb版のみ作成・掲載しております。',
    isExternalLink: false
  }]
};
var IR_INVESTOR_ROUTE = {
  path: '/ir/investor/',
  name: '個人投資家の皆様へ',
  imagePath: '/images/globalnavi-ir-Investor.svg',
  isExternalLink: false,
  subdirectories: [{
    name: 'トップメッセージ',
    path: '/company/topmessage/',
    imagePath: '/images/company-top-message-link.svg',
    isExternalLink: false,
    detail: 'トップメッセージ「リテールDXを通じて世の中を豊かな社会へ」を掲載しております。'
  }, // {
  //   name: 'トライアルグループの事業内容',
  //   path: '/business/',
  //   imagePath: '/images/ir-business-link.svg',
  //   detail:
  //     '日本全国でディスカウントストアを運営している流通小売事業、流通業界に変革をもたらすAIソリューションを開発・提供するリテールAI事業について掲載しております。',
  //   isExternalLink: false,
  // },
  {
    name: 'トライアルグループのあゆみ',
    path: '/company/history/',
    imagePath: '/images/ir-history-link.svg',
    detail: '創業期から培ってきた「流通小売×リテールAI」における挑戦の歴史をご紹介しております。',
    isExternalLink: false
  }, // {
  //   name: '事業計画及び成長可能性',
  //   path: '/ir/library/projection/',
  //   imagePath: '/images/ir-library-projection-link.svg',
  //   detail:
  //     '当社グループのビジネスモデルや、中長期的な成長を実現するための戦略、施策などについて掲載しております。',
  //   isExternalLink: false,
  // },
  // {
  //   name: '業績・財務情報',
  //   path: '/ir/financial/',
  //   imagePath: '/images/ir-financial-link.svg',
  //   detail:
  //     '月次売上高速報や、四半期ごとの決算概要、連結財務諸表、業績予想について掲載しております。',
  //   isExternalLink: false,
  // },
  // {
  //   name: '株主通信',
  //   path: '/ir/library/newsletter/',
  //   imagePath: '/images/news-blog.svg',
  //   detail:
  //     '環境配慮の観点から、株主通信はWeb版のみ作成・掲載しております。',
  //   isExternalLink: false,
  // },
  {
    name: 'ビジネスモデル',
    path: '/retail-investor/business-model/',
    imagePath: '/images/ir-business-link.svg',
    detail: '当社グループのビジネスモデル及び長期的な成長に向けた戦略について掲載しております。',
    isExternalLink: false
  }, {
    name: '業績ハイライト',
    path: '/retail-investor/financial-highlight/',
    imagePath: '/images/globalnavi-ir-financial.svg',
    detail: '業績ハイライトや、業績予想、株主還元について掲載しております。',
    isExternalLink: false
  }, {
    name: 'ココ見てトライアル',
    path: '/retail-investor/topics-cocotora/',
    imagePath: '/images/ir-faq-link.svg',
    detail: '当社グループに関するイチ押しトピックスを掲載しております。',
    isExternalLink: false
  }, // {
  //   name: 'ココ見てトライアル',
  //   path: '/ir/library/newsletter/',
  //   imagePath: '/images/news-blog.svg',
  //   detail:
  //     'ココ見てトライアル。',
  //   isExternalLink: false,
  // },
  {
    name: 'トライアルの株主になりませんか',
    path: '/ir/investor/shareholder/',
    imagePath: '/images/ir-investor-shareholder-link.svg',
    detail: '当社の経営に参加でき、また、配当金を受け取ることができます。',
    isExternalLink: false
  }, {
    name: 'IRメール配信',
    path: '/ir/mail/',
    imagePath: '/images/ir-mail-link.svg',
    detail: '当社の適時開示情報などIR情報について、ご登録のメールアドレスへ配信いたします。',
    isExternalLink: false
  }, {
    name: 'よくあるご質問',
    path: '/ir/faq/',
    imagePath: '/images/ir-faq-link.svg',
    detail: 'よくいただくご質問とその回答について掲載しております。',
    isExternalLink: false
  } // {
  //   name: 'ココ見てトライアル',
  //   path: '/retail-investor/topics-cocotora/',
  //   imagePath: '/images/ir-faq-link.svg',
  //   detail: 'ココ見てトライアル。',
  //   isExternalLink: false,
  // },
  ]
};
var IR_STOCK_ROUTE = {
  path: '/ir/stock/',
  name: '株式情報',
  imagePath: '/images/globalnavi-ir-stock.svg',
  isExternalLink: false,
  subdirectories: [{
    name: '株価情報',
    path: '/ir/stock/price/',
    imagePath: '/images/ir-stock-price.webp',
    detail: '株価チャートを掲載しております。',
    isExternalLink: false
  }, {
    name: '株式基本情報',
    path: '/ir/stock/info/',
    imagePath: '/images/ir-stock-info.webp',
    detail: '当社株式に関する基本情報について掲載しております。',
    isExternalLink: false
  }, {
    name: '株式の状況',
    path: '/ir/stock/situation/',
    imagePath: '/images/ir-stock-situation.webp',
    detail: '株式の発行数、株主数を掲載しております。',
    isExternalLink: false
  }, {
    name: '配当・株主還元',
    path: '/ir/stock/dividend/',
    imagePath: '/images/ir-stock-dividend.webp',
    detail: '利益配分に関する基本方針、配当金の情報について掲載しております。',
    isExternalLink: false
  }, {
    name: '株主総会',
    path: '/ir/stock/meeting/',
    imagePath: '/images/ir-stock-meeting.webp',
    detail: '株主総会の招集通知や決議通知等を掲載しております。',
    isExternalLink: false
  }, {
    name: '定款・株式取扱規程',
    path: '/ir/stock/articles/',
    imagePath: '/images/ir-stock-articles.webp',
    detail: '当社の定款及び株式取扱規程を掲載しております。',
    isExternalLink: false
  }, {
    name: 'アナリストカバレッジ',
    path: '/ir/stock/analyst-coverage/',
    imagePath: '/images/ir-library-projection-link.svg',
    detail: '当社を担当されているアナリストを掲載しております。',
    isExternalLink: false
  }]
};
var IR_OTHER_ROUTE = {
  name: 'その他',
  isExternalLink: false,
  subdirectories: [{
    name: 'IRニュース',
    path: '/ir/news/',
    imagePath: '/images/globalnavi-ir-news.svg',
    isExternalLink: false
  }, {
    name: 'IRカレンダー',
    path: '/ir/calendar/',
    isExternalLink: false
  }, {
    name: 'よくあるご質問',
    path: '/ir/faq/',
    isExternalLink: false
  }, {
    name: 'IRお問い合わせ',
    path: '/contact/ir/',
    isExternalLink: false
  }, {
    name: 'IRメール配信',
    path: '/ir/mail/',
    isExternalLink: false
  }, {
    name: '社外評価',
    path: '/ir/evaluation/',
    isExternalLink: false
  }, {
    name: '電子公告',
    path: '/ir/public-notice/',
    isExternalLink: false
  }, {
    name: '免責事項',
    path: '/ir/disclaimer/',
    isExternalLink: false
  }]
};
var IR_ROUTE = {
  path: '/ir/',
  name: '株主・投資家向け情報',
  subdirectories: [IR_OTHER_ROUTE.subdirectories[0], IR_MANAGE_ROUTE, IR_GOVERNANCE_ROUTE, IR_FINANCIAL_ROUTE, IR_LIBRARY_ROUTE, IR_INVESTOR_ROUTE, IR_STOCK_ROUTE]
};
var IR_PICKUP_ROUTE = [IR_MANAGE_ROUTE, IR_GOVERNANCE_ROUTE, IR_FINANCIAL_ROUTE, IR_LIBRARY_ROUTE, IR_INVESTOR_ROUTE, IR_STOCK_ROUTE];
var CAREERS_ROUTE = {
  path: '/careers/',
  name: '採用情報',
  subdirectories: [{
    path: 'https://www.trial-net.co.jp/recruit/newgraduate/',
    name: '新卒採用',
    imagePath: '/images/careers-newgraduate-links.svg',
    detail: '職種紹介を始め、社員インタビュー等をご覧いただけます。',
    isExternalLink: true
  }, {
    path: 'https://careers.trial-net.co.jp/',
    name: 'キャリア採用',
    imagePath: '/images/careers-trialgp-links.svg',
    detail: '現在募集中のポジション求人等をご覧いただけます。',
    isExternalLink: true
  }, {
    path: 'https://trial-recruit.net/jobfind-pc/',
    name: 'パート・アルバイト',
    imagePath: '/images/careers-jobfind-pc-links.svg',
    detail: 'お住い近くのトライアルで、空いている時間を有効活用して働けます。',
    isExternalLink: true
  }, {
    path: 'https://hrmos.co/pages/retail-ai',
    name: 'Retail AI',
    imagePath: '/images/careers-retail-ai-recruit-links.svg',
    detail: 'Retail AIグループで現在募集中のポジション求人等をご覧いただけます。',
    isExternalLink: true
  }, {
    path: 'https://coordinated-cormorant-2b7.notion.site/for-Engineer-TRIAL-1ce1aa195ef080268a2eca07edc61228',
    name: 'トライアルシステム採用',
    imagePath: '/images/careers-trial-system.svg',
    detail: 'トライアルグループで現在募集中のエンジニアポジション求人等をご覧いただけます。',
    isExternalLink: true
  }]
};
var LEGAL_ROUTE = {
  path: '/legal/',
  name: '法務',
  subdirectories: [{
    name: 'プライバシーポリシー',
    path: '/legal/privacy-policy/',
    isExternalLink: false
  }, {
    name: '利用条件',
    path: '/legal/terms/',
    isExternalLink: false
  }, {
    name: 'SNSポリシー',
    path: '/legal/sns-policy/',
    isExternalLink: false
  }, {
    name: '情報セキュリティポリシー',
    path: '/legal/security-policy/',
    isExternalLink: false
  }, {
    name: '行動規範',
    path: '/legal/code/',
    isExternalLink: false
  }, {
    name: '画像規約',
    path: '/legal/image-terms/',
    isExternalLink: false
  }]
};
var CONTACT_ROUTE = {
  path: '/contact/',
  name: 'お問い合わせ',
  subdirectories: [{
    path: '/contact/media/',
    imagePath: '/images/contact-link.webp',
    name: 'メディアの皆様',
    detail: '取材等に関するお問い合わせ',
    isExternalLink: false
  }, {
    path: '/contact/corporation/',
    imagePath: '/images/contact-link.webp',
    name: '法人のお客様',
    detail: '事業・サービスに関するお問い合わせ・協業のご提案',
    isExternalLink: false
  }, {
    path: '/contact/ir/',
    imagePath: '/images/contact-link.webp',
    name: '株主・投資家の皆様',
    detail: 'IR（株主・投資家向け情報）に関するお問い合わせ',
    isExternalLink: false
  }, {
    path: 'https://www.trial-realestate.co.jp/inquiry/?m=reform&q=thd',
    imagePath: '/images/contact-link.webp',
    name: '出店用地・建物、テナント出店',
    detail: '出店用地・建物、テナント出店に関するお問合せ',
    isExternalLink: true
  }, {
    path: 'https://www.trial-net.co.jp/contacts/',
    imagePath: '/images/contact-link.webp',
    name: '個人のお客様',
    detail: 'トライアル店舗に関するお問い合わせ',
    isExternalLink: true
  }, {
    path: 'https://su-pay.jp/contact/',
    imagePath: '/images/contact-link.webp',
    name: 'SU-PAY',
    detail: 'フィナンシャルサービスに関するお問い合わせ',
    isExternalLink: true
  }]
};
var SITE_MAP_ROUTE = {
  path: '/sitemap',
  name: 'その他',
  subdirectories: [{
    path: '/sitemap/',
    name: 'サイトマップ',
    isExternalLink: false
  }]
};
var PUBLIC_NOTICE_ROUTE = {
  path: '/public-notice',
  name: '電子公告',
  subdirectories: [{
    path: '/public-notice',
    name: '電子公告',
    isExternalLink: false
  }]
};
var NAVIGATIONS = [COMPANY_ROUTE, BUSINESS_ROUTE, NEWS_ROUTE, IR_ROUTE, CAREERS_ROUTE];
var FOOTER_BOTTOM_NAVIGATIONS = [{
  path: CONTACT_ROUTE.path,
  name: CONTACT_ROUTE.name
}].concat((0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(LEGAL_ROUTE.subdirectories), (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(SITE_MAP_ROUTE.subdirectories), (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(PUBLIC_NOTICE_ROUTE.subdirectories));

var CONTACT_SITE_MAP = _objectSpread(_objectSpread({}, CONTACT_ROUTE), {}, {
  subdirectories: CONTACT_ROUTE.subdirectories.map(function (sub) {
    return _objectSpread(_objectSpread({}, sub), {}, {
      name: sub.detail
    });
  })
});

var SITE_MAP_NAVIGATION = [COMPANY_ROUTE, BUSINESS_ROUTE, NEWS_ROUTE, IR_ROUTE, CONTACT_SITE_MAP, CAREERS_ROUTE, LEGAL_ROUTE, SITE_MAP_ROUTE, PUBLIC_NOTICE_ROUTE];

/***/ })

}]);